<div>
	<h1>SmartEEs Showroom</h1>
	<p>Discover more than 35 flexible electronics technologies that could help you in making real your product ideas</p>
</div>
<div class="my-flex-container"  [style.flex-basis]="flexbasis" >
	<showroom-mat-card-view *ngFor="let showroomMatCardViewModel of viewModel.showroomMatCardViewModels" id="{{showroomMatCardViewModel.technologyCategoryName}}" [viewModel]="showroomMatCardViewModel"></showroom-mat-card-view>
</div>
